export default {
      id: "sli-close-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.25bf3227.svg#sli-close",
      toString: function () {
        return this.url;
      }
    }